module.exports = __webpack_public_path__ + "img/视频封面11.fe036f6e.png";